import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from 'components/Modal/config'
import { selectIsLoggedIn } from 'store/selectors'

export const useCheckAuthorizeBeforeAction = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn)

  const { open } = usePageModal()

  function hof<T extends (...args: any[]) => any>(
    func: T
  ): (...funcArgs: Parameters<T>) => ReturnType<T> {
    return (...args: Parameters<T>): ReturnType<T> => {
      if (isLoggedIn) {
        if (typeof func === 'function') return func(...args)
      } else {
        open(MODAL_MODE.LOGIN)
      }
    }
  }

  return useCallback(hof, [isLoggedIn])
}
